define('Contactus.ei1.Main.Model',
[
    'SCModel',
    'Utils'
],
function
(
    SCModelModule,
    Utils
) {
    'use strict';

    var SCModel = SCModelModule.SCModel;

    // Frontend model whose only job is to point Backbone's save() at the
    // extension's backend service file. save() issues a POST to this URL
    // with the form payload as the JSON body, exactly like the Design
    // Request module does.
    function ContactusModel () {
        SCModel.call(this);

        this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    'Modules/Main/SuiteScript2/Contactus.ei1.Main.Service.ss'
                ), true
            );
        };
    }

    ContactusModel.prototype = Object.create(SCModel.prototype);
    ContactusModel.prototype.constructor = ContactusModel;

    return ContactusModel;
});
